import _default from './Ref';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/Ref/index.js
// module id = 114
// module chunks = 0